import { Injectable } from '@angular/core';
import { MemberCardService } from './member-card.service';

@Injectable({ providedIn: 'root' })
export class MemberCardResolver {
  constructor(private memberCardService: MemberCardService) {}

  resolve() {
    return this.memberCardService.fetchCard();
  }
}
